import { render, staticRenderFns } from "./OrderResultList.vue?vue&type=template&id=74046c36&scoped=true&"
import script from "./OrderResultList.vue?vue&type=script&lang=ts&"
export * from "./OrderResultList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderResultList.vue?vue&type=style&index=0&id=74046c36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74046c36",
  null
  
)

export default component.exports